var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.61 117.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.7;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#343838;}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32.8,
    y1: 113.27,
    x2: 32.8,
    y2: 91.93,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343838",
    stopOpacity: 0,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343838",
    stopOpacity: 0.07,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343838",
    stopOpacity: 0.3,
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 65.79,
    y1: -0.18,
    x2: 35.65,
    y2: 29.96,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00DFFC",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00DFFC",
    stopOpacity: 0,
    fill: "#343838"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Privacy &amp;amp; Policy0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.74,117.92V104.66a5.52,5.52,0,0,1,5.52-5.52H49.35a5.52,5.52,0,0,1,5.52,5.52v13.27H65.61V92.38a2.9,2.9,0,0,0-.74-2,3.44,3.44,0,0,0-.81-.61H2.71A2.86,2.86,0,0,0,0,92.57v25.36Z",
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.61 12.03 52.85 12.03 52.85 0.87 64.61 12.03",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.8,26.43A9.82,9.82,0,0,0,23,36.23v7.35H42.61V36.23A9.82,9.82,0,0,0,32.8,26.43Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.8,53.39a4.89,4.89,0,0,0-2.45,9.12V68.1a2.45,2.45,0,1,0,4.9,0V62.52a4.89,4.89,0,0,0-2.45-9.12Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.71,89.75H64.06a3.44,3.44,0,0,0,.81-.61,2.9,2.9,0,0,0,.74-2V17.5H50.24a2.84,2.84,0,0,1-2.86-2.73V0H2.86A2.84,2.84,0,0,0,0,2.73v84.2A2.86,2.86,0,0,0,2.71,89.75Zm8-40.65a5.52,5.52,0,0,1,5.52-5.52H18.1V36.23a14.71,14.71,0,0,1,29.42,0v7.35h1.84a5.52,5.52,0,0,1,5.52,5.52V74.84a5.52,5.52,0,0,1-5.52,5.52H16.26a5.52,5.52,0,0,1-5.52-5.52Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.86,1,64.61,46.75V18.5H49.24a2.84,2.84,0,0,1-2.85-2.73V1Z",
    fill: "#343838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/PrivacyPolicy.868df2b61e201f39265615c0bb8d1913.svg";
export { ForwardRef as ReactComponent };